import request from '@/utils/request'
import axios from "axios";

//刷新token
export function refreshToken(){
    return request({
        method:'get',
        url:'account/refresh-token',
    })
}

//退出登录
export function logout(){
    return request({
        method:'get',
        url:'account/logout',
    })
}

//账号信息
export function getUserInfo(){
    return request({
        method:'get',
        url:'account/info',
    })
}

//密码验证码
export function passwordVerificationCode(params){
    return request({
        method:'post',
        url:'account/password-code',
        data:params
    })
}

//重置密码
export function resetPassword(params){
    return request({
        method:'post',
        url:'account/reset-password',
        data:params
    })
}

